module.exports = __webpack_public_path__ + "static/media/gift.e4b96b39.svg";